import React from "react";
import { Button } from "@/v2/components/ui/button";

export class GiftPageErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: any }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }
  componentDidCatch(error: any, errorInfo: any) {
    console.error("GiftPage Error Caught:", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 text-center text-foreground bg-card rounded-2xl border border-border m-8 max-w-xl mx-auto shadow-md">
          <h2
            className="text-xl font-bold"
            style={{ color: "var(--v2-foreground)" }}
          >
            Something went wrong loading this page
          </h2>
          <p className="text-sm text-muted-foreground mt-2">
            {String(
              this.state.error?.message ||
                this.state.error ||
                "Unknown rendering error",
            )}
          </p>
          <Button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 bg-action text-white hover:bg-action-hover"
          >
            Reload Page
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
